import type { TRoleType } from 'core/model/interfaces/role.interface';
import type { TSliceReducer } from 'core/store';
import { initialState } from './constants';
import type { IUserSessionState } from './types';

export const clearUserSessionState: TSliceReducer<IUserSessionState> = state => {
  Object.assign(state, initialState);
};

export const setUserRole: TSliceReducer<IUserSessionState, Array<TRoleType>> = (state, { payload }) => {
  state.role = payload;
};

export const setSubject: TSliceReducer<IUserSessionState, string> = (state, { payload }) => {
  state.subject = payload;
};

export const reducers = { clearUserSessionState, setUserRole, setSubject };
